import React from 'react';
import { AritoDialog, AritoForm, AritoHeaderTabs, AritoIcon, BottomActionBarV2 } from '@/components/custom/erp';
import { initialSearchValues, SearchFormSchema } from '../../schema';
import { BasicInfoTab } from './BasicInfoTab';
import { DetailTab } from './DetailTab';
import { OtherTab } from './OtherTab';

interface SearchDialogProps {
  openSearchDialog: boolean;
  onCloseSearchDialog: () => void;
  onSearch: (data: any) => void;
  searchFieldStates: any;
}

const SearchDialog = ({ openSearchDialog, onCloseSearchDialog, onSearch, searchFieldStates }: SearchDialogProps) => {
  const handleSubmit = (data: any) => {
    onSearch({
      ...data,
      ngay_ct1: data.ngay_ct1 || '',
      ngay_ct2: data.ngay_ct2 || '',
      so_ct1: data.so_ct1 || '',
      so_ct2: data.so_ct2 || '',
      dien_giai: data.dien_giai || '',
      status: data.status === 'ALL' ? '' : data.status,
      user_id0: data.user_id0 === 'ALL' ? '' : data.user_id0,
      ma_kh: searchFieldStates.customer?.uuid || '',
      ma_ngvkt: searchFieldStates.profession?.uuid || '',
      tk_no: searchFieldStates.accountDebit?.uuid || '',
      tk_co: searchFieldStates.accountCredit?.uuid || '',
      ma_unit: searchFieldStates.unit?.uuid || ''
    });
    onCloseSearchDialog();
  };

  return (
    <AritoDialog
      open={openSearchDialog}
      onClose={onCloseSearchDialog}
      title='Lọc chứng từ'
      maxWidth='xl'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoForm
        mode='add'
        hasAritoActionBar={false}
        schema={SearchFormSchema}
        onSubmit={handleSubmit}
        initialData={initialSearchValues}
        className='w-[900px]'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
            <BasicInfoTab />

            <AritoHeaderTabs
              tabs={[
                {
                  id: 'detail_tab',
                  label: 'Chi tiết',
                  component: <DetailTab searchFieldStates={searchFieldStates} />
                }
              ]}
            />

            <div className='border-t border-gray-200'>
              <OtherTab searchFieldStates={searchFieldStates} />
            </div>
          </div>
        }
        bottomBar={<BottomActionBarV2 onClose={onCloseSearchDialog} mode='add' />}
      />
    </AritoDialog>
  );
};

export default SearchDialog;
